"use strict";

exports.__esModule = true;
exports.FlexColumnFields = FlexColumnFields;
var _react = _interopRequireDefault(require("react"));
var _core = require("@blueprintjs/core");
var _Translator = require("../../Core/Translator");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
/**
 * Fields for FlexColumnElement.
 */
function FlexColumnFields(props) {
  var element = props.element,
    path = props.path,
    elementEditor = props.elementEditor;
  return /*#__PURE__*/_react["default"].createElement(_Translator.Translator, null, function (_ref) {
    var translate = _ref.translate;
    return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_core.FormGroup, {
      label: translate("FlexColumn.gutter.label", "Gutter Size"),
      helperText: translate("FlexColumn.gutter.helperText", "The size of the gap between items in the column.")
    }, /*#__PURE__*/_react["default"].createElement(_core.Slider, {
      labelRenderer: false,
      min: 0,
      max: 100,
      value: element.props.gutter || 0,
      onChange: function onChange(value) {
        return elementEditor.setProp(path, "gutter", value);
      }
    })));
  });
}